export const TRASH = 'TRASH';
export const RECYCLE = 'RECYCLE';
export const RESTROOM_MALE = 'RESTROOM_MALE';
export const RESTROOM_FEMALE = 'RESTROOM_FEMALE';
export const TIME_BASED_TASK = 'TIME_BASED';
export const SUPPLY = 'SUPPLY';
export const CART_BANANA_BOAT = 'CART_BANANA_BOAT';
export const DUMPSTER = 'DUMPSTER';

export const DEFAULT_CANS_THRESHOLD = 80;
export const DEFAULT_TIME_BASED_THRESHOLD = 60;

export const SEPARATE_TRASH_TEXT = {
  separateTrashAndRecycleActive: 'Trash and Recycle cans will be deployed separately.',
  separateTrashAndRecycleInactive: 'Trash and Recycle cans will be deployed together.',
}

export const THINGS_ATTRIBUTES_CONFIG = {
  TRASH: [
    {
      label: 'Trash Can Type',
      type: 'dropdown',
      values: [
        {
          label: 'Full',
          value: 'Full'
        },
        {
          label: 'Half',
          value: 'Half'
        },
        {
          label: 'Flip',
          value: 'Flip'
        }
      ],
      key: 'type'
    },
    {
      label: 'Bagged',
      type: 'checkbox',
      key: 'bagged'
    },
    {
      label: 'Paired',
      type: 'checkbox',
      key: 'paired'
    },
    {
      label: 'Outdoor',
      type: 'checkbox',
      key: 'outdoor'
    },
    {
      label: 'Ashtray',
      type: 'checkbox',
      key: 'ashtray'
    }
  ],
  RECYCLE: [
    {
      label: 'Bagged',
      type: 'checkbox',
      key: 'bagged'
    },
    {
      label: 'Paired',
      type: 'checkbox',
      key: 'paired'
    },
    {
      label: 'Outdoor',
      type: 'checkbox',
      key: 'outdoor'
    },
    {
      label: 'Ashtray',
      type: 'checkbox',
      key: 'ashtray'
    }
  ],
  RESTROOM_MALE: [
    {
      label: 'Stalls',
      type: 'number',
      key: 'stalls'
    },
    {
      label: 'Urinals',
      type: 'number',
      key: 'urinals'
    },
    {
      label: 'Sinks',
      type: 'number',
      key: 'sinks'
    },
    {
      label: 'Hand Dryers',
      type: 'number',
      key: 'dryers'
    },
    {
      label: 'Towel Dispensers',
      type: 'number',
      key: 'towelDispensers'
    },
    {
      label: 'Changing Stations',
      type: 'number',
      key: 'changingStations'
    }
  ],
  RESTROOM_FEMALE: [
    {
      label: 'Stalls',
      type: 'number',
      key: 'stalls'
    },
    {
      label: 'Sinks',
      type: 'number',
      key: 'sinks'
    },
    {
      label: 'Hand Dryers',
      type: 'number',
      key: 'dryers'
    },
    {
      label: 'Towel Dispensers',
      type: 'number',
      key: 'towelDispensers'
    },
    {
      label: 'Changing Stations',
      type: 'number',
      key: 'changingStations'
    }
  ]
};

export const THING_TYPES_TO_ICON = {
  TRASH: 'trash',
  RECYCLE: 'recycle',
  RESTROOM_MALE: 'restroom-men',
  RESTROOM_FEMALE: 'restroom-women',
  TIME_BASED: 'timebased',
  SUPPLY: 'supply',
  CART_BANANA_BOAT: 'trashcart',
  DUMPSTER: 'dumpster'
}

export const THING_TYPES_TO_LABELS = {
  'RESTROOM_MALE': 'Men',
  'RESTROOM_FEMALE': 'Women',
  'TRASH': 'Trash',
  'RECYCLE': 'Recycle',
  'TIME_BASED': 'Time-Based',
  'SUPPLY': 'Supply',
  'CART_BANANA_BOAT': 'Trash Cart',
  'DUMPSTER': 'Dumpster'
};

export const THINGS_LIST_TABS = [
  {
    name: 'cans',
    label: 'Cans',
    addText: 'New Can',
    searchText: 'Filter by can name',
    hasTypeFilter: true,
    hasStatusFilter: true,
    thingTypeDisplay: 'Can',
    types: [
      {
        'label': 'All Can Types',
        'value': TRASH + ',' + RECYCLE
      },
      {
        'label': 'Trash Only',
        'value': TRASH
      },
      {
        'label': 'Recycle Only',
        'value': RECYCLE
      }
    ],
    statuses: [
      {
        'label': 'All Statuses',
        'value': ''
      },
      {
        'label': 'Active',
        'value': 'active'
      },
      {
        'label': 'Inactive',
        'value': 'inactive'
      }
    ],
    form: {
      addText: 'Add New Can',
      hasAttributes: true,
      hasStatus: true,
      hasTypes: true,
      statusActiveText: 'Can is active and is available for deployment.',
      statusInactiveText: 'Can is inactive and is not available for deployment.',
      nameText: 'Can Name',
      typeText: 'Can Type',
      types: [
        {
          label: 'Trash',
          value: TRASH
        },
        {
          label: 'Recycle',
          value: RECYCLE
        }
      ]
    },
    details: {
      title: 'Can Details for ',
      about: [
        {
          label: 'ID Number',
          key: 'thingId',
          pipe: undefined
        },
        {
          label: 'Can Type',
          key: 'type',
          pipe: 'formatThingType'
        },
        {
          label: 'Site',
          key: 'worldName',
          pipe: undefined
        },
        {
          label: 'Property',
          key: 'kingdomName',
          pipe: undefined
        },
        {
          label: 'Latitude',
          key: 'lat',
          pipe: 'number: "1.2-6"'
        },
        {
          label: 'Longitude',
          key: 'lon',
          pipe: 'number: "1.2-6"'
        }
      ],
      hasAttributes: true,
      hasThresholds: true
    }
  },
  {
    name: 'restrooms',
    label: 'Restrooms',
    addText: 'New Restroom',
    searchText: 'Filter by restroom name',
    hasTypeFilter: true,
    hasStatusFilter: true,
    thingTypeDisplay: 'Restroom',
    types: [
      {
        'label': 'All Restrooms',
        'value': RESTROOM_MALE + ',' + RESTROOM_FEMALE
      },
      {
        'label': "Men's Restrooms Only",
        'value': RESTROOM_MALE
      },
      {
        'label': "Women's Restrooms Only",
        'value': RESTROOM_FEMALE
      }
    ],
    statuses: [
      {
        label: 'All Statuses',
        value: ''
      },
      {
        label: 'Active & Open',
        value: 'active and open'
      },
      {
        label: 'Active & Closed',
        value: 'active and closed',
      },
      {
        label: 'Inactive',
        value: 'inactive'
      }
    ],
    form: {
      addText: 'Add New Restroom',
      hasAttributes: true,
      hasStatus: true,
      hasTypes: true,
      openingText: 'Restroom Opening',
      statusActiveText: 'Restroom is active.',
      statusInactiveText: 'Restroom is inactive and is not available for deployment.',
      statusOpenText: 'Restroom is open and is available for deployment.',
      statusClosedText: 'Restroom is closed and is not available for deployment.',
      nameText: 'Restroom Name',
      typeText: 'Gender',
      types: [
        {
          label: 'Men',
          value: RESTROOM_MALE
        },
        {
          label: 'Women',
          value: RESTROOM_FEMALE
        }
      ]
    },
    details: {
      title: 'Restroom Details for ',
      about: [
        {
          label: 'ID Number',
          key: 'thingId'
        },
        {
          label: 'Gender',
          key: 'type'
        },
        {
          label: 'Site',
          key: 'worldName'
        },
        {
          label: 'Property',
          key: 'kingdomName'
        },
        {
          label: 'Latitude',
          key: 'lat',
          pipe: 'number: "1.2-6"'
        },
        {
          label: 'Longitude',
          key: 'lon',
          pipe: 'number: "1.2-6"'
        }
      ],
      hasAttributes: true,
      hasThresholds: true
    }
  },
  {
    name: 'time-based',
    label: 'Time-Based',
    addText: 'New Time-Based',
    searchText: 'Filter by time-based location name',
    hasTypeFilter: false,
    hasStatusFilter: true,
    thingTypeDisplay: 'Time-based location',
    types: [
      {
        label: 'Time-Based',
        value: TIME_BASED_TASK
      }
    ],
    statuses: [
      {
        label: 'All Statuses',
        value: ''
      },
      {
        label: 'Active & Open',
        value: 'active and open'
      },
      {
        label: 'Active & Closed',
        value: 'active and closed',
      },
      {
        label: 'Inactive',
        value: 'inactive'
      }
    ],
    form: {
      addText: 'Add New Time-Based Location',
      hasAttributes: false,
      hasStatus: true,
      hasTypes: false,
      openingText: 'Time-Based Location Opening',
      statusActiveText: 'Time-based location is active.',
      statusInactiveText: 'Time-based location is inactive and is not available for deployment.',
      statusOpenText: 'Time-based location is open and is available for deployment.',
      statusClosedText: 'Time-based location is closed and is not available for deployment.',
      nameText: 'Time-Based Location Name',
      typeText: '',
      types: [
        {
          label: 'Time-Based',
          value: TIME_BASED_TASK
        }
      ]
    },
    details: {
      title: 'Time-Based Location Details for ',
      about: [
        {
          label: 'ID Number',
          key: 'thingId'
        },
        {
          label: 'Site',
          key: 'worldName'
        },
        {
          label: 'Property',
          key: 'kingdomName'
        },
        {
          label: 'Latitude',
          key: 'lat',
          pipe: 'number: "1.2-6"'
        },
        {
          label: 'Longitude',
          key: 'lon',
          pipe: 'number: "1.2-6"'
        }
      ],
      hasAttributes: false,
      hasThresholds: true
    }
  },
  {
    name: 'resources',
    label: 'Resources',
    addText: 'Add Resource',
    searchText: 'Filter by resource name',
    hasTypeFilter: false,
    hasStatusFilter: false,
    thingTypeDisplay: 'Resource',
    types: [
      {
        value: SUPPLY,
        label: 'Supply'
      },
      {
        value: CART_BANANA_BOAT,
        label: 'Trash Cart'
      },
      {
        value: DUMPSTER,
        label: 'Dumpster'
      }
    ],
    statuses: [],
    form: {
      addText: 'Add New Resource',
      hasAttributes: false,
      hasStatus: false,
      hasTypes: true,
      hasThreshold: false,
      nameText: 'Resource Name',
      typeText: 'Resource Type',
      types: [
        {
          label: 'Dumpster',
          value: DUMPSTER
        },
        {
          label: 'Supply',
          value: SUPPLY
        },
        {
          label: 'Trash Cart',
          value: CART_BANANA_BOAT
        }
      ]
    },
    details: {
      title: 'Resource Details for ',
      about: [
        {
          label: 'Resource Type',
          key: 'type'
        },
        {
          label: 'Site',
          key: 'worldName'
        },
        {
          label: 'Property',
          key: 'kingdomName'
        },
        {
          label: 'Latitude',
          key: 'lat',
          pipe: 'number: "1.2-6"'
        },
        {
          label: 'Longitude',
          key: 'lon',
          pipe: 'number: "1.2-6"'
        }
      ],
      hasAttributes: false,
      hasThresholds: false
    }
  }
];



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/constants/things.constants.ts